import React, { useContext } from 'react'
import { trackEvent } from 'uneeq-react-core'
import Overlay from '../generic/Overlay'
// @ts-ignore
import useDimensions from 'react-use-dimensions'
import { useIsSmallScreen } from 'uneeq-react-core'
import { UneeqContext } from 'uneeq-react-core'
import { isMobileSafari } from 'react-device-detect'
import { Box } from 'rebass'

export interface PermissionsVideo {
  permissionsMP4: any
  permissionsWebm: any
}

interface PermissionsPromptProps {
  video: PermissionsVideo
}

const PermissionsPrompt: React.FC<PermissionsPromptProps> = ({ video }) => {
  const { config } = useContext(UneeqContext)
  const isSmallScreen = useIsSmallScreen()

  const [heightRef, { width, height }] = useDimensions()
  let videoWidth = 0
  let shift = 0

  if (width && height && isSmallScreen) {
    videoWidth = height * config.avatarAspect // full width of the video at this height
    const avatarLeft = videoWidth * (config.avatarPosition + 0.05) // where the avatar is within video
    const center = width / 2 // the center of the frame - where we want the avatar to be
    shift = Math.min(0, center - avatarLeft) // How far to shift the video over to center
  }

  const setRefs = (ref: React.ReactElement) => {
    heightRef(ref)
  }

  const { permissionsMP4, permissionsWebm } = video
  trackEvent('permissions-prompt', 'state-change')
  return (
    <Overlay>
      <Box
        label="permissions-video-container"
        sx={{
          height: '100%',
          width: '100%',
          minWidth: videoWidth,
          marginLeft: -shift
        }}
        ref={setRefs}
      >
        <video
          autoPlay={true}
          loop={true}
          playsInline={true}
          controls={true}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        >
          <source src={permissionsWebm} type="video/webm" />
          <source src={permissionsMP4} type="video/mp4" />
          Loading...
        </video>
      </Box>
    </Overlay>
  )
}

export default PermissionsPrompt
